var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGelule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.91 24.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #99cfe2;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.49,1.49c.9.94,1.4,2.08,1.42,3.43,0,.3,0,.61,0,.92,0,4.61,0,9.22,0,13.83,0,.56-.08,1.11-.26,1.64-.17.52-.43.99-.76,1.42-.24.32-.52.61-.84.86-.92.73-1.96,1.1-3.14,1.09-1.03,0-1.97-.31-2.82-.9-.36-.25-.68-.55-.96-.89C.38,21.96,0,20.89,0,19.7,0,14.79,0,9.88,0,4.97,0,3.99.27,3.09.8,2.27c.25-.39.55-.73.89-1.03C3.44-.29,5.8-.33,7.5.71c.35.21.69.49.99.78M1,12.88c0,.06,0,.12,0,.18v2.15c0,1.5,0,3,0,4.5,0,1.29.63,2.52,1.68,3.25.79.55,1.66.79,2.61.71,1.19-.11,2.14-.65,2.86-1.61.35-.48.58-1.01.7-1.59.05-.27.07-.54.07-.82v-6.61s0-.07,0-.1c0-.03,0-.06-.01-.07H1M8.92,11.82c0-.08,0-.14,0-.21v-6.56s0-.1,0-.15c-.04-1.32-.58-2.37-1.64-3.16-.64-.48-1.37-.72-2.17-.75-.97-.03-1.84.25-2.6.85-.38.3-.7.66-.95,1.08-.38.64-.56,1.33-.56,2.07,0,2.22,0,4.45,0,6.67,0,.05,0,.1,0,.16h7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.53,2.52c.5-.49,1.07-.84,1.7-1.1.2-.08.39-.06.57.06.23.16.22.47-.02.61-.04.02-.07.04-.11.06-.35.14-.68.32-.98.54-.51.39-.91.88-1.12,1.49-.1.29-.15.58-.15.88,0,.4,0,.8,0,1.21,0,.03,0,.06,0,.1,0,.18-.09.29-.24.37-.18.09-.36.08-.54-.01-.14-.07-.21-.19-.21-.35,0-.14,0-.28,0-.42,0-.3,0-.6,0-.9,0-.68.2-1.31.57-1.88.16-.24.34-.47.53-.66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGelule);
export default __webpack_public_path__ + "static/media/gelule.17b13a38069770ad4a16361bf92467ed.svg";
export { ForwardRef as ReactComponent };